<template>
  <div>
    <v-row>
      <!-- <v-col cols="12" md="7"> -->
      <!-- <div>
        <v-btn
          icon
          color="primary"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div> -->
      <v-col cols="12" md="1" class="d-flex align-center">
        <v-btn
          icon
          color="primary"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <!-- </v-col> -->
      <v-col cols="12" md="9" class="d-flex align-center justify-center">
        <v-alert
          v-model="alert"
          dense
          type="info"
          class="text-center caption mb-0"
          dismissible
          >{{ $t("Complete_your_profile") }}</v-alert
        >
      </v-col>
      <!-- <v-col cols="12" md="5" > -->
      <v-col cols="12" md="2" class="d-flex align-center">
        <v-btn
         
          color="primary"
          dark
          @click="changeEdit()"
        >
          <v-icon left>{{ tab.icon }}</v-icon>
          {{ tab.title }}
        </v-btn>
        
      </v-col>
      <!-- </v-col> -->
    </v-row>
    <v-row class="mt-7">
      <v-col cols="12" md="12">
        <profile-details v-if="!edit" />
        <edit-profile v-if="edit" :candidateObj="candidate()"  @changeEdit="changeEdit"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EditProfile from '../components/EditProfile.vue'
import ProfileDetails from '../components/ProfileDetails.vue'
import { mapGetters } from "vuex";
export default {
  name: 'Profile',
  components: { ProfileDetails, EditProfile },
  data: () => ({
    edit: false
  }),
  computed: {
    ...mapGetters({
      currentUser: "auth/getCurrentUser",
    }),
    tab () {
      return this.edit
        ? { title: this.$t('form_candidate_profile'), icon: 'mdi-eye' }
        : { title: this.$t('Editprofile'), icon: 'mdi-pencil' }
    },
    
  },
  methods: {
    changeEdit () {
      this.edit = !this.edit
    },
    candidate() {
      if(this.edit){
        return this.currentUser ? this.currentUser.candidate : {};
      }else{
        return {};
      }
      
    },
  }
}
</script>